import styled from '@emotion/styled'
import { Avatar as MuiAvatar, Grid2 as Grid, Typography } from '@mui/material'
import React from 'react'

import useT from '@/i18n/useT'

const Avatar = styled(MuiAvatar)`
  margin-right: ${props => props.theme.spacing(2)};
`

export type UserAvatarPropsOptions = {
  includeName?: boolean
}
export type UserAvatarProps = {
  firstName: string
  lastName: string
  profileImageUrl?: string | null
}
export const UserAvatar: React.FC<
  UserAvatarProps & UserAvatarPropsOptions
> = props => {
  const { firstName, lastName, profileImageUrl, includeName = false } = props
  const { t } = useT()
  return (
    <Grid container alignItems="center">
      {profileImageUrl ? (
        <Avatar alt={t('userAvatar.profile.alt')} src={profileImageUrl} />
      ) : (
        <>
          <Avatar>
            {firstName[0]}
            {lastName[0]}
          </Avatar>
        </>
      )}
      {includeName && (
        <Typography>
          {firstName} {lastName}
        </Typography>
      )}
    </Grid>
  )
}
